var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from "react";
import InputField from "@frameworks/web/components/generic/inputField";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
import { EMandateType, mandateMaxAmt, mandateMinAmt, mandateTypeRadioList, } from "../MutualFundConstant";
import { acceptNumberOnly, } from "@frameworks/web/components/features/TOC/constant";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import GenericSelect from "@frameworks/shared-library/components/GenericSelect/GenericSelect";
import newMandate from "@frameworks/shared-library/assets/images/generic/newMandate.svg";
import GenericTooltip from "@frameworks/shared-library/components/GenericTooltip";
import GenericTooltipInnerContent from "@frameworks/shared-library/components/GenericTooltipInnerContent";
import xFasterTag from "@frameworks/shared-library/assets/images/markets/xFasterTag.svg";
var CreateNewMandateData = function (props) {
    var _a, _b, _c, _d, _e;
    var device = DeviceContext();
    useEffect(function () {
        tocDi.mandate
            .mandateSwitch()
            .then(function (data) {
            if (data && data.digital && data.physical) {
                if (data.digital == true)
                    props.setMandateType(EMandateType.EMANDATE);
                else if (data.physical == true)
                    props.setMandateType(EMandateType.PHYSICAL);
            }
        })
            .catch(function (error) { return console.log(error); })
            .finally(function () { });
    }, []);
    return (React.createElement("div", { className: "d-flex justify-content-between flex-column h-100" },
        React.createElement("div", { className: "mandate-form-container" },
            React.createElement("div", { className: "d-flex align-items-baseline gap-2 mb-30" },
                !props.isTriggeredFromOrderBook && (React.createElement("i", { className: "edel-icon-left-shortArrow", onClick: function () {
                        props.setBack();
                    } })),
                React.createElement("div", null,
                    React.createElement("label", { className: "DMSansNormal_20_400 txt-midnight-blue-shade2 d-flex align-items-center gap-2" },
                        "New Mandate",
                        " ",
                        React.createElement(GenericTooltip, { placement: "bottom", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: "Mandate is a daily transaction limit up to which entity can transact with your bank account. You will be creating this mandate in favour of Indian Clearing Corp. Once created the mandate can be used for active systematic transfers (or SIP) Orders." }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info", noButton: true, button: React.createElement("i", { className: "edel-icon-Information txt_secondary-gray info-block fs-15" }) })),
                    React.createElement("div", { className: "DMSans_13_400 txt-whispering-periwinkle" },
                        "Setup automatic payments using ",
                        " ",
                        mandateTypeRadioList.find(function (x) { return x.value === props.mandateType; })
                            .display))),
            ((_a = props.bankList) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement("div", { className: "d-flex align-items-start gap-2 mb-30 new-mandate-section" },
                React.createElement("i", { className: "txt_lavender-blue edel-icon-touchscreen" }),
                React.createElement("div", { className: "w-100" },
                    React.createElement("label", { className: "DMSans_13_400 txt_blackOne1 pb-15" }, "Select Account"),
                    React.createElement("div", { className: "mandate-bank-select w-100" },
                        React.createElement(GenericSelect, { className: "mandate-select DMSansMedium_15_400 txt-midnight-blue", classNamePrefix: "bank-select-dropdown", options: props.bankList.map(function (x) {
                                var digit = x.bnkAcNo.slice(-4);
                                return {
                                    label: x.bnkNm + "-XXXX" + digit,
                                    value: x.bnkAcNo,
                                };
                            }), value: {
                                label: ((_b = props.selectedBank) === null || _b === void 0 ? void 0 : _b.bnkNm) +
                                    "-XXXX" +
                                    ((_c = props.selectedBank) === null || _c === void 0 ? void 0 : _c.bnkAcNo.slice(-4)),
                                value: ((_d = props.selectedBank) === null || _d === void 0 ? void 0 : _d.bnkAcNo)
                                    ? (_e = props.selectedBank) === null || _e === void 0 ? void 0 : _e.bnkAcNo
                                    : "",
                            }, onChange: function (data) {
                                props.bankList.find(function (bank) {
                                    if (bank.bnkAcNo === data.value) {
                                        props.setSelectedBank(__assign({}, bank));
                                    }
                                });
                            } }))))),
            React.createElement("div", { className: "d-flex align-items-start gap-2 mb-30 new-mandate-section" },
                React.createElement("i", { className: "edel-icon-Transaction-border txt_lavender-blue" }),
                React.createElement("div", { className: "w-100" },
                    React.createElement("label", { className: "DMSans_13_400 txt_blackOne1 pb-15" },
                        "Set Transaction Limit",
                        props.mandateType === EMandateType.EMANDATE && React.createElement(React.Fragment, null, " (eNach)")),
                    React.createElement("div", { className: "mandate-bank-select w-100" },
                        React.createElement(InputField, { autofocus: true, integer: true, inputMode: "numeric", type: "number", placeholderClassName: "RobotoR_14_400 txt-midnight-blue", placeholder: "min amt ".concat(mandateMinAmt[props.mandateType]), maxLength: 8, inputPattern: "[0-9]*", defaultValue: props.amount, className: "mandate-amount", onKeyDown: function (e) {
                                if (e.key === "." || acceptNumberOnly(e.key)) {
                                    e.preventDefault();
                                }
                            }, onWheel: function (e) {
                                return e.currentTarget.blur();
                            }, onChange: function (value) {
                                props.setAmount(value);
                                if (!value ||
                                    (value &&
                                        Number(value) <
                                            mandateMinAmt[props.mandateType])) {
                                    props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                                            status: true,
                                            msg: "Minimum transfer amount is Rs ".concat(mandateMinAmt[props.mandateType]),
                                        } }));
                                }
                                else if (value &&
                                    Number(value) >
                                        mandateMaxAmt[props.mandateType]) {
                                    props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                                            status: true,
                                            msg: "Amount can not be more than ".concat(mandateMaxAmt[props.mandateType]),
                                        } }));
                                }
                                else {
                                    props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: { status: false, msg: "" } }));
                                }
                            }, required: true, onBlur: function (values, e) {
                                // props.setAmount(e.target.value);
                            } }),
                        !!props.formErrors.amount.msg && (React.createElement("div", { className: "text-danger DMSansNormal_12_400 d-flex" },
                            React.createElement("span", null,
                                React.createElement("i", { className: "edel-icon-validation pe-1 align-middle" })),
                            React.createElement("span", null, props.formErrors.amount.msg))),
                        React.createElement("p", { className: "ps-3 DMSans_13_400 txt_secondary-gray pt-10 d" }, "Min limit is \u20B950,000. ".concat(props.mandateType === EMandateType.EMANDATE
                            ? "Mandate takes 2-3 days to approve."
                            : "Physical Mandate takes 7-14 days to be approved after submission of signed mandate document", " "),
                            React.createElement(GenericTooltip, { placement: "bottom", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: props.mandateType === EMandateType.EMANDATE
                                        ? "The ₹50,000 limit ensures secure and manageable transactions. Approval in 2-3 days allows banks to verify details and prevent fraud."
                                        : "Physical mandates require manual processing and verification, which can lead to delays" }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info", noButton: true, externalClassName: "d-ruby mx-1", button: React.createElement("span", { className: "txt-han-blue" }, "Know Why?") }))))),
            React.createElement("hr", null),
            React.createElement("div", { className: "mt-30 DMSans_13_400 txt-whispering-periwinkle d-flex justify-content-center" }, mandateTypeRadioList.map(function (x) {
                return (React.createElement(React.Fragment, null, props.mandateType !== x.value && (React.createElement("div", { onClick: function () {
                        props.setMandateType(x.value);
                    }, className: "DMSans_13_400" },
                    React.createElement("span", { className: "txt-han-blue" }, "Switch "),
                    React.createElement("span", null,
                        "to ",
                        x.display,
                        x.value === EMandateType.EMANDATE && (React.createElement("img", { src: xFasterTag, alt: "xFaster", className: "ms-1" })))))));
            }))),
        React.createElement("div", { className: "d-flex justify-content-end pt-10" },
            React.createElement("img", { src: newMandate, alt: "Mandate", className: "position-relative mandate-icon" }))));
};
export default CreateNewMandateData;
